import { render } from "./SideBarLink.vue?vue&type=template&id=2bcfd0e8&scoped=true"
import script from "./SideBarLink.vue?vue&type=script&lang=js"
export * from "./SideBarLink.vue?vue&type=script&lang=js"

import "./SideBarLink.vue?vue&type=style&index=0&id=2bcfd0e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcfd0e8"]])

export default __exports__